/**
 * SideMenu
 */

// React
import React, { useEffect, useState } from 'react';

// UI
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    Button,
  Paper,
  Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import downloadVideo from 'client-sdk/src/video/download';
import handleError from '../../utils/handleError';
import VideoModal from '../Modal/video';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerBox: {
        marginLeft: "24px",

        marginBottom: "15px",
        marginTop: "15px"
    },
    icons: {
        cursor: "pointer",
        display: "block"
    },
    video: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#FEEAD37D",
        borderRadius: "4px",
        textDecoration: "none",
        color: "#383836",
        padding: "6px 12px",
        marginRight: "50px"
    }
  })
);

const videos = {
    "/orders-create": "SINGLE_ORDER",
    "/orders": "BATCH_ORDER",
    "/parcels-sender": "SINGLE_PARCEL",
    "/products": "SINGLE_PRODUCT"
}

export default function TopBar(props: any) {
  const classes = useStyles();
  const [video, setVideo] = useState()
  const [videoLoading, setVideoLoading] = useState(false)
  const [dialog, setDialog] = useState("")
  const [videoType, setVideoType] = useState("")

  useEffect(() => {
    setVideoType(videos[window.location.pathname])
  }, [window.location.pathname])

  const fetchVideo = async () => {
    try {
      setVideoLoading(true)
      const response = await downloadVideo(videoType)
      const reader = response?.body?.getReader();
      let buffer = [];
      while (1) {
        const { value, done } = await reader?.read();
        if (done) {
          const blob = new Blob(buffer);
          const blobUrl = URL.createObjectURL(blob);
          setVideo(blobUrl)
          break;
        }
        buffer.push(value);
      }
      setVideoLoading(false)
    } catch (err) {
      setVideoLoading(false)
      handleError(err.response)
    }
  }
  const onVideoOpen = () => {
    setDialog("VIDEO")
    fetchVideo()
  }

  return (
    <>
    <Paper
        style={{
        //   width: '100%',
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "66px",
          borderRadius: '0',
          zIndex: 4,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '97px',
          left: "24px",
          paddingRight: "24px",
          paddingLeft: "48px",
          borderBottomLeftRadius: "4px",
          borderBottomRightRadius: "4px"
        }}
      >
          <Typography component="p">
            به پنل روناد خوش آمدید
          </Typography>
          <div style={{display: "flex", alignItems: "center"}}>
            {videoType && <Button onClick={onVideoOpen} className={classes.video}>
                <span style={{marginLeft: "24px"}}>وید‌ئو آموزشی</span>
                <img src="/cameraIcon.svg"/>
            </Button>}
            {/* <img src='/ringicon.svg' className={classes.icons} /> */}
            <Link to="/alltickets"><img src='/headset.svg' className={classes.icons} style={{marginRight: "12px"}} title='پشتیبانی'/></Link>
            <Link to="/profile"><img src='/usericon.svg' className={classes.icons} style={{marginRight: "12px"}} title="حساب کاربری"/></Link>
          </div>
          {/* <Button
            variant='outlined'
            color='secondary'
            style={{ marginRight: "15px" }}
            onClick={onVideoOpen}
            disabled={videoLoading}
          >
            ویدئو آموزشی
          </Button> */}
      </Paper>
      <VideoModal src={video} onClose={() => setDialog("")} open={dialog === "VIDEO"} loading={videoLoading} />
      </>
  );
}
